import { createClient } from '@/prismicio';
import { AuthorDocument } from '../../prismicio-types';
import { notFound } from 'next/navigation';

export async function getBlogPost(uid: string) {
  const client = createClient();
  const blog = await client
    .getByUID('blog', uid, {
      // This `fetchLinks` option solves everything.
      // It tells Prismic to also retrieve the specified fields
      // from any linked author and blog_category documents.
      fetchLinks: [
        'author.name',
        'author.avatar',
        // Add any other author fields you need here
        'blog_category.name', // <-- The essential fix for your category issue
      ],
    })
    .catch(() => notFound());
  const authorReference = blog.data.author as unknown as AuthorDocument;
  let author: Partial<AuthorDocument> = {
    data: {
      name: 'Devsu',
      avatar: {},
      company: null,
      job_title: null,
      bio: [],
      slices: [],
      meta_title: '',
      meta_description: '',
      meta_image: {},
      keywords: '',
    },
  };

  try {
    if (authorReference?.uid) {
      author = await client.getByUID('author', authorReference.uid);
    }
  } catch {
    // Do nothing
  }

  return { blog, author };
}
